import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

const META_CONSTANTS = {
  APPLICATION_STATUS: 'application_status',
  ASSIGNMENT_TYPE: 'assignment_type',
  ASSIGNMENT_DIRECT: 'assignment_direct',
  EXPENSE_DESCRIPTION_NEW: 'expense_description_new',
  EXPENSE_DESCRIPTION_OLD: 'expense_description_old'
};

const NAMES = {
  PROJECT_ACCEPT                     : 'project_accept',
  PROJECT_ACTIVE                     : 'project_active',
  PROJECT_ADVANCE_AGREED             : 'project_advance_agreed',
  PROJECT_ADVANCE_CANCEL             : 'project_advance_cancel',
  PROJECT_ADVANCE_CREATE             : 'project_advance_create',
  PROJECT_APPROVE_PRICE              : 'project_approve_price',
  PROJECT_AUTO_CANCELED              : 'project_auto_canceled',
  PROJECT_AUTO_DECLINED              : 'project_auto_declined',
  PROJECT_BUYER_COMPLETE             : 'project_buyer_complete',
  PROJECT_BUYER_COVER_SELLER_FEES    : 'project_buyer_cover_seller_fees',
  PROJECT_CANCEL_COMMIT              : 'project_cancel_confirm',
  PROJECT_CANCEL_REQUEST             : 'project_cancel_request',
  PROJECT_CANCEL_WITHDRAW            : 'project_cancel_withdraw',
  PROJECT_CANCELLED                  : 'project_cancelled',
  PROJECT_CANCELLED_STALE            : 'project_cancelled_stale',
  PROJECT_COMPLETE_CONFIRM           : 'project_complete_confirm',
  PROJECT_COMPLETE_REQUEST           : 'project_complete_request',
  PROJECT_COMPLETE_WITHDRAW          : 'project_complete_withdraw',
  PROJECT_COMPLETED                  : 'project_completed',
  PROJECT_CREATE                     : 'project_create',
  PROJECT_DECLINE                    : 'project_decline',
  PROJECT_DELIVERED_LINK             : 'project_delivered_link',
  PROJECT_EXPEDITE_REQUEST           : 'project_expedite_request',
  PROJECT_EXPEDITE_CANCEL            : 'project_expedite_cancel',
  PROJECT_EXPENSE_CREATE             : 'project_expense_create',
  PROJECT_EXPENSE_DELETE             : 'project_expense_delete',
  PROJECT_EXPENSE_UPDATE             : 'project_expense_update',
  PROJECT_EXPENSES_ENABLED           : 'project_expenses_enabled',
  PROJECT_EXPENSES_DISABLED           : 'project_expenses_disabled',
  PROJECT_FILE_ATTACH                : 'project_file_attach',
  PROJECT_FILE_DETACH                : 'project_file_detach',
  PROJECT_OFFER                      : 'project_offer',
  PROJECT_PRICE_CHANGED              : 'project_price_changed',
  PROJECT_REOPENED                   : 'project_reopened',
  PROJECT_WITHDRAW                   : 'project_withdraw'
};

export const ACTION = {
  META_CONSTANTS,
  NAMES,
};

const Action = ShModel.extend({
  name: attr('string'),
  field: attr('string'),
  oldValue: attr('string'),
  newValue: attr('string'),
  createdAt: attr('date'),
  updatedAt: attr('date'),
  /** @type {Object} */
  details: attr('json'),
  humanName: attr('string'),

  //Relationships
  actionable: belongsTo('shModel', {
    async: false,
    polymorphic: true,
  }),
  user: belongsTo('user', {
    async: false,
    inverse: null,
  }),
});

export default Action;
